module.exports = __webpack_public_path__ + "img/mip-logo.8da31c4d.svg";